import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { createFileViews } from '../utils';

import Accordion from '../../Accordion';
import Carot from '../../../../global/icons/Carot';
import Heading from '../../Accordion/Heading';

const AltHeading = styled(Heading)`
  background-color: ${p =>
    p.active ? p.theme.color.primary : p.theme.color.tertiary};
  border: 1px solid ${p => p.theme.color.borderPrimary};
  border-bottom: none;
  color: ${p =>
    p.active ? p.theme.color.tertiary : p.theme.color.textPrimary};
  display: flex;
  font-size: 14px;
  font-weight: ${p => p.theme.fontWeight.semibold};
  justify-content: space-between;
  padding: 20px;
  width: 100%;

  &::before,
  &::after {
    display: none;
  }
`;

const StyledAccordion = styled(Accordion)`
  border-bottom: 1px solid ${p => p.theme.color.borderPrimary};
  margin-top: 32px;
  max-width: 100%;
`;

const AltIcon = styled(Carot).attrs(p => ({
  strokeColor: p.active ? p.theme.color.tertiary : p.theme.color.primary
}))`
  display: inline;
  transform: rotate(${p => (p.active ? 180 : 0)}deg);
`;

/**
 * Transform the lit data into something useable by the Accordion component
 * @param {Array} data literature data
 */
const transformData = data => {
  const sections = [];
  data.forEach(category => {
    sections.push({
      id: category.categoryName,
      label: category.categoryName,
      subCategories: category.subCategories,
      view: () =>
        category.literature.length > 0
          ? createFileViews(category.literature)
          : null
    });
  });
  return sections;
};

const LitAccordion = ({ data }) => {
  const accordionData = transformData(data[0]);

  return (
    <StyledAccordion
      AltHeading={AltHeading}
      AltIcon={AltIcon}
      sections={accordionData}
      allSubCategories={data[1]}
    />
  );
};

LitAccordion.propTypes = {
  data: PropTypes.array
};

export default LitAccordion;
